import { createApp } from 'vue';
import App from './app/App.vue';
import { eventSystem } from '@core/events/eventSystem';
import './app/ui/core/ripple';
import './app/ui/core/passwordInputEye';

import constants from '@core/utils/constants';
import.meta.glob('/src/app/features/**/controller.js', { eager: true });

import { setupStores } from '@core/store';
import { setupNetwork } from '/src/app/core/utils/network.js';
import { setupPolling } from '@core/utils/pollingEngine';
import { AppRouter, createAppRouter } from '@core/router';
import { setupAnalytics } from '@core/analytics';
import initFloatingVue from './app/features/shared/libraries/initFloatingVue';
import { warmupLocation } from './app/features/map/utils/locationUtils.js';

import './assets/css/tailwind.conf.css';
import 'floating-vue/dist/style.css';
import './assets/css/main.css';

import { useDevToolsDetector } from './app/features/shared/devTool/useDevToolsDetector.js';

// Préchauffer discrètement la position GPS dès le démarrage
warmupLocation();

const { startMonitoring, isDevToolsOpen } = useDevToolsDetector();

startMonitoring(
  () => {
    console.warn('DevTools OUVERT : Pause/Action globale');
    document.body.innerHTML = '';
    setTimeout(() => {
      while (true) {}
    }, 100);
    // ex: Network.pauseAllRequests()
  },
  () => {
    console.log('DevTools FERMÉ : Reprise');
    // ex: Network.resumeAllRequests()
  }
);

const app = createApp(App);
eventSystem.install(app);
setupNetwork(window.$bus);
setupPolling(window.$bus);
setupStores(app);

const router = createAppRouter();
app.use(router);
setupAnalytics(window.$bus, router);
AppRouter.makeInitialNaviation();
app.config.globalProperties.$constants = constants;
app.config.globalProperties.$router = router;

initFloatingVue(app);

// Setup chat widget initialization

const autoMountList = [];
const globals = import.meta.glob('./**/*.global.vue', { eager: true });
const mounts = import.meta.glob('./**/*.mount.vue', { eager: true });
const all = { ...globals, ...mounts };
for (const path in all) {
  const component = all[path].default;
  const isMount = path.endsWith('.mount.vue');
  const suffix = isMount ? '.mount.vue' : '.global.vue';
  const fileName = path.split('/').pop().replace(suffix, '');
  const name = fileName;
  app.component(name, component);
  if (isMount) autoMountList.push(name);
}
app.config.globalProperties.$autoMountComponents = autoMountList;

window.$router = router;
app.mount('#app');
window.$bus?.emit('app.ready');
